export enum OpenClosedStates {
  Opening,
  Open,
  Closing,
  Closed,
}
